import axios from 'axios'
const header = {
  'x-api-key': process.env.REACT_APP_X_API_KEY_EMAIL_SERVICE
}
export default axios.create({
  baseURL: process.env.REACT_APP_BASE_URL_EMAIL_SERVICE,
  headers: { ...header }
})